import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { PageWithLayout } from '@/pages/_app';
import { Helmet } from 'react-helmet-async';
import { Permission } from '@/models/user';
import { VoucherTemplateListContent } from '@starjack/widgets/voucherTemplates';

const VoucherTemplates: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Gutscheinvorlagen | Starjack Backoffice</title>
            </Helmet>

            <VoucherTemplateListContent />
        </>
    );
};

VoucherTemplates.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
VoucherTemplates.isProtected = true;
VoucherTemplates.permissions = [Permission.ADMIN];

export default VoucherTemplates;
